import { authService } from '../auth/auth.service';
import config from '../config/config';
import store from '../store';
import endpoint from '../util/endpoint';
import { service } from '@whiz-cart/node-shared/service/service';
import { bound } from '@whiz-cart/ui-shared/decorators/bound';

class PingService {
    handles: (() => void)[] = [];

    async start() {
        this.stop();

        const { pingInterval = 15 * 60 * 1000 } = config as {
            pingInterval?: number;
        };

        const timer = setInterval(this.sendNoParams, pingInterval);
        this.handles.push(() => clearInterval(timer));

        this.handles.push(
            store.subscribeState(
                ({ url }) => url.params?.storeGuid,
                (storeGuid, previousStoreGuid) => {
                    this.send(storeGuid, previousStoreGuid);
                },
            ),
        );

        this.handles.push(authService.loginState.subscribe((state) => state.isLoggedIn, this.sendNoParams));

        window.addEventListener('focus', this.sendNoParams);
        this.handles.push(() => window.removeEventListener('focus', this.sendNoParams));
    }

    stop() {
        for (const handle of this.handles) {
            handle();
        }
        this.handles = [];
    }

    @bound sendNoParams() {
        this.send();
    }

    @bound async send(storeGuid?: string, previousStoreGuid?: string) {
        const { isLoggedIn } = authService.loginState.getState();
        if (!isLoggedIn) return;

        if (!storeGuid) storeGuid = await store.awaitState((state) => state.url.params.storeGuid);
        try {
            await endpoint('storeManager.ping').post({ storeGuid, previousStoreGuid });
            console.debug('Sent ping', [previousStoreGuid, storeGuid].join(' -> '));
        } catch (e) {
            console.warn('Failed to send ping:', e);
        }
    }
}

export default service('pingService', PingService);
